import {Observable} from "rxjs";
import {ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot} from "@angular/router";
import {inject, Injectable} from "@angular/core";

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard {
    canDeactivate(component: CanComponentDeactivate,
                  route: ActivatedRouteSnapshot,
                  state: RouterStateSnapshot) {

        return component.canDeactivate ? component.canDeactivate() : true;
    }
}

const canDeactivateWithGuard: CanDeactivateFn<CanComponentDeactivate> = (
    component: CanComponentDeactivate,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    return inject(CanDeactivateGuard).canDeactivate(component, route, state);
};
export {canDeactivateWithGuard};
